import { Component, Inject, ViewChild } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { TextModes } from '../../../ui/controls/text-input/text-input.component';
import { UIErrorHandler } from '../../../../core/uiErrorHandler';
import { FormMode } from '../../../../core/constants';
import { User } from '../../../../models/users/user';
import { UserFormComponent } from '../../user-form/user-form.component';
import { LoadingSpinnerComponent } from '../../../loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-edit-user-info-dialog',
  templateUrl: './edit-user-info-dialog.component.html',
  standalone: false,
})
export class EditUserInfoDialogComponent {
  @ViewChild('userForm') userForm: UserFormComponent | undefined;

  user: User | undefined;
  merchantId: string | undefined;
  TextModes = TextModes;
  FormMode = FormMode;
  isNew = false;

  constructor(
    private uiErrorHandler: UIErrorHandler,
    public dialogRef: MatDialogRef<EditUserInfoDialogComponent>,
    public loadingSpinnerDialog: MatDialog,

    @Inject(MAT_DIALOG_DATA)
    public data: {
      user: User;
      merchantId: string;
    },
  ) {
    this.user = data.user;

    if (!this.user) {
      this.isNew = true;
      this.user = new User(User.createEmpty());
    }

    this.merchantId = data.merchantId;
  }

  btnCancel_click() {
    this.dialogRef.close(false);
  }

  btnSave_click() {
    let loadingSpinnerRef = this.loadingSpinnerDialog.open(
      LoadingSpinnerComponent,
      {
        disableClose: true,
        panelClass: 'transparent-dialog',
        data: {
          mode: 'indeterminate',
        },
      },
    );
    try {
      //this.saveChanges()
      this.userForm?.save()?.then((user) => {
        loadingSpinnerRef.close();
        this.dialogRef.close({ user: user, error: null });
      });
    } catch (e) {
      this.dialogRef.close({ user: null, error: e });
      this.uiErrorHandler.handleError(e);
    }
  }
}
